import * as actions from "./actions";
import logics from "./logics";
import reducer from "./reducer";
import * as selectors from "./selectors";
import * as types from "./types";

export default {
    actions,
    logics,
    reducer,
    selectors,
    types,
};
